!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactHFNComponents = t(require("react")) : e.ReactHFNComponents = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 12);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(6)();
  }, function (e, t, r) {
    e.exports = r(8);
  }, function (e, t, r) {
    var n = r(9),
        o = r(10),
        a = r(11);

    e.exports = function (e, t) {
      return n(e) || o(e, t) || a();
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    };
  }, function (e, t) {
    function r(e, t, r, n, o, a, i) {
      try {
        var s = e[a](i),
            c = s.value;
      } catch (e) {
        return void r(e);
      }

      s.done ? t(c) : Promise.resolve(c).then(n, o);
    }

    e.exports = function (e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (o, a) {
          var i = e.apply(t, n);

          function s(e) {
            r(i, o, a, s, c, "next", e);
          }

          function c(e) {
            r(i, o, a, s, c, "throw", e);
          }

          s(void 0);
        });
      };
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(7);

    function o() {}

    function a() {}

    a.resetWarningCache = o, e.exports = function () {
      function e(e, t, r, o, a, i) {
        if (i !== n) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, r) {
    var n = function (e) {
      "use strict";

      var t = Object.prototype,
          r = t.hasOwnProperty,
          n = "function" == typeof Symbol ? Symbol : {},
          o = n.iterator || "@@iterator",
          a = n.asyncIterator || "@@asyncIterator",
          i = n.toStringTag || "@@toStringTag";

      function s(e, t, r, n) {
        var o = t && t.prototype instanceof l ? t : l,
            a = Object.create(o.prototype),
            i = new O(n || []);
        return a._invoke = function (e, t, r) {
          var n = "suspendedStart";
          return function (o, a) {
            if ("executing" === n) throw new Error("Generator is already running");

            if ("completed" === n) {
              if ("throw" === o) throw a;
              return j();
            }

            for (r.method = o, r.arg = a;;) {
              var i = r.delegate;

              if (i) {
                var s = b(i, r);

                if (s) {
                  if (s === u) continue;
                  return s;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = c(e, t, r);

              if ("normal" === l.type) {
                if (n = r.done ? "completed" : "suspendedYield", l.arg === u) continue;
                return {
                  value: l.arg,
                  done: r.done
                };
              }

              "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
            }
          };
        }(e, r, i), a;
      }

      function c(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      e.wrap = s;
      var u = {};

      function l() {}

      function p() {}

      function f() {}

      var d = {};

      d[o] = function () {
        return this;
      };

      var y = Object.getPrototypeOf,
          h = y && y(y(E([])));
      h && h !== t && r.call(h, o) && (d = h);
      var m = f.prototype = l.prototype = Object.create(d);

      function g(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function v(e) {
        var t;

        this._invoke = function (n, o) {
          function a() {
            return new Promise(function (t, a) {
              !function t(n, o, a, i) {
                var s = c(e[n], e, o);

                if ("throw" !== s.type) {
                  var u = s.arg,
                      l = u.value;
                  return l && "object" == typeof l && r.call(l, "__await") ? Promise.resolve(l.__await).then(function (e) {
                    t("next", e, a, i);
                  }, function (e) {
                    t("throw", e, a, i);
                  }) : Promise.resolve(l).then(function (e) {
                    u.value = e, a(u);
                  }, function (e) {
                    return t("throw", e, a, i);
                  });
                }

                i(s.arg);
              }(n, o, t, a);
            });
          }

          return t = t ? t.then(a, a) : a();
        };
      }

      function b(e, t) {
        var r = e.iterator[t.method];

        if (void 0 === r) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, b(e, t), "throw" === t.method)) return u;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return u;
        }

        var n = c(r, e.iterator, t.arg);
        if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, u;
        var o = n.arg;
        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, u) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, u);
      }

      function w(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function x(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function O(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(w, this), this.reset(!0);
      }

      function E(e) {
        if (e) {
          var t = e[o];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var n = -1,
                a = function t() {
              for (; ++n < e.length;) {
                if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
              }

              return t.value = void 0, t.done = !0, t;
            };

            return a.next = a;
          }
        }

        return {
          next: j
        };
      }

      function j() {
        return {
          value: void 0,
          done: !0
        };
      }

      return p.prototype = m.constructor = f, f.constructor = p, f[i] = p.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, i in e || (e[i] = "GeneratorFunction")), e.prototype = Object.create(m), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, g(v.prototype), v.prototype[a] = function () {
        return this;
      }, e.AsyncIterator = v, e.async = function (t, r, n, o) {
        var a = new v(s(t, r, n, o));
        return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, g(m), m[i] = "Generator", m[o] = function () {
        return this;
      }, m.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, e.values = E, O.prototype = {
        constructor: O,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !e) for (var t in this) {
            "t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function n(r, n) {
            return i.type = "throw", i.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
                i = a.completion;
            if ("root" === a.tryLoc) return n("end");

            if (a.tryLoc <= this.prev) {
              var s = r.call(a, "catchLoc"),
                  c = r.call(a, "finallyLoc");

              if (s && c) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              } else if (s) {
                if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return n(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var a = o;
              break;
            }
          }

          a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
          var i = a ? a.completion : {};
          return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, u) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), u;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), x(r), u;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                x(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, r) {
          return this.delegate = {
            iterator: E(e),
            resultName: t,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), u;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = n;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
        var r = [],
            n = !0,
            o = !1,
            a = void 0;

        try {
          for (var i, s = e[Symbol.iterator](); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          o = !0, a = e;
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (o) throw a;
          }
        }

        return r;
      }
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);

    var n = r(0),
        o = r.n(n),
        a = r(1),
        i = r.n(a),
        s = function s(e) {
      var t = e.type,
          r = e.msg;
      return o.a.createElement("div", {
        className: "alert alert-".concat(t)
      }, r);
    };

    s.defaultProps = {
      type: "primary"
    }, s.propTypes = {
      type: i.a.string,
      msg: i.a.string.isRequired
    };
    var c = s,
        u = r(2),
        l = r.n(u),
        p = r(4),
        f = r.n(p),
        d = r(5),
        y = r.n(d);

    function h(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function m() {
      return (m = y()(l.a.mark(function e(t) {
        var r, n, o;
        return l.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.props, e.prev = 1, r.setIsVerifying(!0), e.next = 5, r.storageRef.getDownloadURL();

              case 5:
                return n = e.sent, e.next = 8, r.storageRef.getMetadata();

              case 8:
                o = e.sent, r.setIsVerifying(!1), r.setFile({
                  fileName: o.customMetadata.fileName,
                  bytes: o.size,
                  fullPath: o.fullPath,
                  contentType: o.contentType,
                  downloadURL: n
                }), e.next = 16;
                break;

              case 13:
                e.prev = 13, e.t0 = e.catch(1), r.setIsVerifying(!1);

              case 16:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[1, 13]]);
      }))).apply(this, arguments);
    }

    function g(e) {
      !function (e) {
        m.apply(this, arguments);
      }({
        props: e.props
      });
    }

    var v = function v(e) {
      return o.a.useEffect(g.bind(null, {
        props: e
      }), []), function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? h(Object(r), !0).forEach(function (t) {
            f()(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }({}, e);
    };

    function b(e) {
      var t,
          r,
          n = v(e),
          a = n.isVerifying,
          i = n.file;
      return o.a.createElement(o.a.Fragment, null, (null === (t = e.components) || void 0 === t ? void 0 : t.fileLink) && o.a.createElement(e.components.fileLink, {
        isVerifying: a,
        file: i
      }), !(null === (r = e.components) || void 0 === r ? void 0 : r.fileLink) && o.a.createElement("div", {
        className: "FileLink"
      }, a && o.a.createElement(c, {
        type: "info",
        msg: e.isVerifyingMessage
      }), (null == i ? void 0 : i.downloadURL) && (null == i ? void 0 : i.fileName) && o.a.createElement("a", {
        href: i.downloadURL
      }, i.fileName)));
    }

    b.propTypes = {
      isVerifyingMessage: i.a.string,
      storageRef: i.a.object.isRequired,
      file: i.a.object,
      components: i.a.object
    }, b.defaultProps = {
      isVerifyingMessage: "Verifying..."
    };

    var w = b,
        x = function x(e) {
      var t = e.msg;
      return o.a.createElement("div", {
        className: "help-block"
      }, t);
    };

    x.propTypes = {
      msg: i.a.string.isRequired
    };

    var O = x,
        E = function E(e) {
      var t = e.progress,
          r = e.striped,
          n = e.type;
      return o.a.createElement("div", {
        className: "progress ".concat(r && "progress-striped")
      }, o.a.createElement("div", {
        className: "progress-bar ".concat(n && "progress-bar-" + n),
        role: "progressbar",
        "aria-valuenow": t,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        style: {
          width: "".concat(t, "%")
        }
      }, o.a.createElement("span", {
        className: "sr-only"
      }, t, "% Complete")));
    };

    E.propTypes = {
      progress: i.a.number.isRequired,
      striped: i.a.bool,
      type: i.a.string
    };
    var j = E,
        P = r(3),
        L = r.n(P);

    function T(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function S(e, t) {
      e.props;
      var r = e.states.setProgress,
          n = t.bytesTransferred,
          o = t.totalBytes;
      0 !== o && r(n / o * 100);
    }

    function _(e, t) {
      e.props;
      var r = e.states;
      r.setUploadError(t), r.setIsUploading(!1);
    }

    function k(e) {
      return R.apply(this, arguments);
    }

    function R() {
      return (R = y()(l.a.mark(function e(t) {
        var r, n, o, a, i, s;
        return l.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.props, n = t.states, t.uploadTask, o = t.file, e.next = 3, Promise.resolve(r.storageRef.getDownloadURL());

              case 3:
                return a = e.sent, n.setIsUploading(!1), e.next = 7, r.storageRef.getMetadata();

              case 7:
                i = e.sent, s = {
                  fileName: i.customMetadata.fileName,
                  bytes: o.size,
                  fullPath: i.fullPath,
                  contentType: i.contentType,
                  downloadURL: a
                }, r.onUpload && r.onUpload(s), n.setProgress(100), setTimeout(function () {
                  n.setProgress(0), n.setUploaded(!0), r.setFile(s);
                }, 800);

              case 12:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))).apply(this, arguments);
    }

    function I(e, t) {
      return N.apply(this, arguments);
    }

    function N() {
      return (N = y()(l.a.mark(function e(t, r) {
        var n, o, a, i;
        return l.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                n = t.props, o = t.states, a = r.target.files.item(0), o.setIsUploading(!0), o.setProgress(20), (i = n.storageRef.put(a, {
                  customMetadata: {
                    fileName: a.name
                  }
                })).on("state_changed", S.bind(null, {
                  props: n,
                  states: o
                }), _.bind(null, {
                  props: n,
                  states: o
                }), k.bind(null, {
                  props: n,
                  states: o,
                  uploadTask: i,
                  file: a
                }));

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))).apply(this, arguments);
    }

    function U(e) {
      e.props;
      e.states.setType("file");
    }

    function F(e, t) {
      var r,
          n = e.props,
          o = e.states,
          a = n.maxBytes,
          i = o.setMaxBytesExceeded,
          s = t.target.files.item(0);
      return !!s && (s.size > a ? (i(!0), (r = {
        props: n,
        states: o
      }).props, (0, r.states.setType)(""), !1) : (i(null), !0));
    }

    function B(e, t) {
      return D.apply(this, arguments);
    }

    function D() {
      return (D = y()(l.a.mark(function e(t, r) {
        var n, o;
        return l.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = t.props, o = t.states, r.preventDefault(), r.stopPropagation(), o.setMaxBytesExceeded(!1), o.setIsUploading(!1), o.setUploaded(!1), !F({
                  props: n,
                  states: o
                }, r)) {
                  e.next = 10;
                  break;
                }

                return e.next = 10, I({
                  props: n,
                  states: o
                }, r);

              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))).apply(this, arguments);
    }

    var M = function M(e) {
      var t = o.a.useState(!1),
          r = L()(t, 2),
          n = r[0],
          a = r[1],
          i = o.a.useState(!1),
          s = L()(i, 2),
          c = s[0],
          u = s[1],
          l = o.a.useState(0),
          p = L()(l, 2),
          d = p[0],
          y = p[1],
          h = o.a.useState("file"),
          m = L()(h, 2),
          g = m[0],
          v = m[1],
          b = o.a.useState(null),
          w = L()(b, 2),
          x = w[0],
          O = w[1],
          E = o.a.useState(!1),
          j = L()(E, 2),
          P = j[0],
          S = {
        maxBytesExceeded: n,
        setMaxBytesExceeded: a,
        type: g,
        setType: v,
        isUploading: c,
        setIsUploading: u,
        progress: d,
        setProgress: y,
        uploadError: x,
        setUploadError: O,
        uploaded: P,
        setUploaded: j[1]
      };
      return o.a.useEffect(U.bind(null, {
        props: e,
        states: S
      }), [g]), function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? T(Object(r), !0).forEach(function (t) {
            f()(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : T(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }({}, e, {
        progress: d,
        maxBytesExceeded: n,
        isUploading: c,
        type: g,
        uploaded: P,
        handleInput: B.bind(null, {
          props: e,
          states: S
        })
      });
    },
        q = function q(e) {
      var t = M(e),
          r = t.components,
          n = t.type,
          a = t.name,
          i = t.label,
          s = t.maxBytes,
          u = t.maxBytesError,
          l = t.progress,
          p = t.handleInput,
          f = t.maxBytesExceeded,
          d = t.isUploading,
          y = t.file,
          h = t.disabled,
          m = t.required,
          g = t.uploaded,
          b = t.isVerifying;
      return v(e), o.a.createElement(o.a.Fragment, null, (null == r ? void 0 : r.fileInput) && o.a.createElement(o.a.Fragment, null, o.a.createElement(r.fileInput, {
        type: n,
        name: a,
        label: i,
        maxBytes: s,
        maxBytesError: u,
        progress: l,
        handleInput: p,
        maxBytesExceeded: f,
        isUploading: d,
        uploaded: g,
        isVerifying: b,
        file: y,
        required: m
      })), !(null == r ? void 0 : r.fileInput) && o.a.createElement("div", {
        className: "form-group"
      }, o.a.createElement(w, e), o.a.createElement("br", null), o.a.createElement("label", null, i), o.a.createElement("input", {
        type: n,
        name: a,
        onInput: p,
        disabled: h,
        required: m
      }), o.a.createElement("br", null), d && !g && o.a.createElement(j, {
        type: "info",
        striped: !0,
        progress: l
      }), g && o.a.createElement(c, {
        type: "info",
        msg: "Uploaded..."
      }), o.a.createElement(O, {
        msg: "".concat(s.toFixed(), " kB")
      }), f && o.a.createElement(c, {
        type: "danger",
        msg: "".concat(u)
      })));
    };

    q.propTypes = {
      components: i.a.object,
      label: i.a.string,
      name: i.a.string,
      type: i.a.string,
      disabled: i.a.bool,
      required: i.a.bool,
      maxBytes: i.a.number,
      maxBytesError: i.a.string,
      file: i.a.object,
      setFile: i.a.func,
      storageRef: i.a.object.isRequired
    }, q.defaultProps = {
      maxBytes: 1048576,
      name: "file",
      type: "file",
      disabled: !1,
      required: !1
    };

    var V = q,
        G = function G(e) {
      return o.a.createElement("div", null, o.a.createElement(V, e));
    };

    function C(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    var A = function A(e) {
      var t = o.a.useState(null),
          r = L()(t, 2),
          n = r[0],
          a = r[1],
          i = o.a.useState(!1),
          s = L()(i, 2);
      return function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? C(Object(r), !0).forEach(function (t) {
            f()(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : C(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }({}, e, {
        file: n,
        setFile: a,
        isVerifying: s[0],
        setIsVerifying: s[1]
      });
    },
        z = function z(e) {
      var t = A(e);
      return o.a.createElement("div", null, e.readOnly && o.a.createElement(w, t), !e.readOnly && o.a.createElement(G, t));
    };

    z.propTypes = {
      readOnly: i.a.bool.isRequired
    };
    var H = z;
    r.d(t, "FirebaseFileInput", function () {
      return H;
    }), r.d(t, "FirebaseFileLink", function () {
      return w;
    });
  }]);
});